var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDeactivateAccount = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 39,
  height: 39,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Deactivate-account_svg__a)",
  d: "M19.5 37C29.165 37 37 29.165 37 19.5S29.165 2 19.5 2 2 9.835 2 19.5 9.835 37 19.5 37Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#EDCFFF",
  strokeWidth: 2,
  d: "M19.5 38C29.717 38 38 29.717 38 19.5S29.717 1 19.5 1 1 9.283 1 19.5 9.283 38 19.5 38Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Deactivate-account_svg__b)",
  d: "M19.5 32.888c7.393 0 13.387-5.994 13.387-13.388S26.893 6.113 19.5 6.113c-7.394 0-13.388 5.993-13.388 13.387S12.106 32.888 19.5 32.888Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Deactivate-account_svg__c)",
  d: "M32.862 20.308 20.185 7.63a.835.835 0 0 0-1.522.48v6.146c0 .283.142.534.357.685l11.765 11.764a13.311 13.311 0 0 0 2.077-6.397Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Deactivate-account_svg__d)",
  d: "M32.888 19.5c0-.415-.02-.825-.057-1.23l-5.936-5.936a10.335 10.335 0 0 0-3.752-2.472.837.837 0 0 0-1.133.783c0 .284.144.545.375.697l5.247 5.27a8.59 8.59 0 0 1 .315 4.651c-.02-.017-11.097-11.08-11.097-11.08a.835.835 0 0 0-.993-.32C11.9 11.362 9.1 15.234 9.2 19.733a10.27 10.27 0 0 0 3.13 7.149l5.95 5.949c.401.036.808.056 1.22.056 7.394 0 13.388-5.994 13.388-13.388Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M22.01 10.645c0 .346.213.658.537.78 3.251 1.231 5.571 4.372 5.583 8.047.015 4.73-3.832 8.621-8.563 8.657-4.789.037-8.696-3.848-8.696-8.63 0-3.682 2.318-6.833 5.572-8.07a.837.837 0 1 0-.586-1.568C11.9 11.364 9.1 15.236 9.2 19.735c.123 5.543 4.675 10.026 10.22 10.069 5.717.044 10.383-4.595 10.383-10.303 0-4.4-2.771-8.163-6.66-9.638a.837.837 0 0 0-1.133.783Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Deactivate-account_svg__e)",
  d: "M32.888 19.5c0 7.394-5.994 13.388-13.388 13.388-.412 0-.819-.02-1.22-.057l-5.917-5.915a10.28 10.28 0 0 0 7.056 2.887c5.718.044 10.384-4.595 10.384-10.303a10.267 10.267 0 0 0-2.908-7.166l5.936 5.935c.037.406.057.816.057 1.231Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M19.5 15.092a.837.837 0 0 1-.837-.836V8.11a.837.837 0 0 1 1.674 0v6.146a.837.837 0 0 1-.837.836Z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "Deactivate-account_svg__a",
  x1: 19.5,
  x2: 19.5,
  y1: 11.83,
  y2: 32.292,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B55CFD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.366,
  stopColor: "#BE58FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.818,
  stopColor: "#754DF7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#764DF7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Deactivate-account_svg__c",
  x1: 25.798,
  x2: 17.807,
  y1: 17.479,
  y2: 9.489,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3F049E",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3F049E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Deactivate-account_svg__d",
  x1: 28.611,
  x2: 12.536,
  y1: 28.606,
  y2: 12.529,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#5412C0",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5412C0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Deactivate-account_svg__e",
  x1: 33.846,
  x2: 20.969,
  y1: 33.839,
  y2: 20.962,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#5412C0",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5412C0"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Deactivate-account_svg__b",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "translate(19.5 19.5) scale(17.5166)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3F049E",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3F049E"
})))));
export { SvgDeactivateAccount as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiOWRlOTU2MDVmZGVkODVkYzA5YjJiMjljOWY1OThkMDEuc3ZnIjs=";